import { useMutation } from '@tanstack/react-query';
import { sendTestMerchantNotifications } from 'config/requests/merchants';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useNotify } from 'react-admin';

type UseCreateMerchantNotificationReturnValue = {
  isLoading: boolean;
  sendTestNotification: VoidFunction;
};

export function useSendTestNotification(
  notificationId: string,
  onSuccess: VoidFunction,
): UseCreateMerchantNotificationReturnValue {
  const translate = useTypedTranslate();

  const notify = useNotify();

  const { mutate: sendTestNotification, isPending } = useMutation({
    mutationFn: () => sendTestMerchantNotifications(notificationId),
    onSuccess: () => {
      onSuccess();
      notify(translate('app.merchantsShowNotifications.testNotificationSent'), { type: 'success' });
    },
    onError: () => {
      notify(translate('app.merchantsShowNotifications.testNotificationSendingError'), {
        type: 'error',
      });
    },
  });

  return { isLoading: isPending, sendTestNotification };
}
